(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["buildyourbox"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const dropdowns = document.querySelectorAll('.dropdown');
  
  dropdowns.forEach(function(dropdown) {
    const productContainer = dropdown.closest('.cartproduct');
    const priceDisplay = productContainer.querySelector('.cartproduct__original');
    const originalPriceDisplay = productContainer.querySelector('.cartproduct__compareprice');
    const stockDisplay = productContainer.querySelector('.productstock');
    
    updateProductInfo(dropdown, priceDisplay, originalPriceDisplay, stockDisplay);
    
    dropdown.addEventListener('change', function() {
      updateProductInfo(dropdown, priceDisplay, originalPriceDisplay, stockDisplay);
    });
  });

  function updateProductInfo(dropdown, priceDisplay, originalPriceDisplay, stockDisplay) {
    const selectedOption = dropdown.querySelector('option:checked');
    if (selectedOption) {
      const newPrice = getNearestPrice(dropdown, 'data-price');
      const originalPrice = selectedOption.getAttribute('original-price') || '';
      const stock = selectedOption.getAttribute('data-stock');
      
      const isStarterPack = dropdown.closest('#starterpark') !== null;
      
      if (priceDisplay) {
        priceDisplay.textContent = isStarterPack ? `${newPrice} / box` : newPrice;
        priceDisplay.style.display = 'block';
      }
      
      if (originalPriceDisplay) {
        if (originalPrice) {
          originalPriceDisplay.textContent = isStarterPack ? `${originalPrice} / box` : originalPrice;
          originalPriceDisplay.style.display = 'block';
        } else {
          originalPriceDisplay.style.display = 'none';
        }
      }
      
      if (stockDisplay) {
        if (stock > 0 && stock <= 10) {
          stockDisplay.textContent = 'Only ' + stock + ' left!';
          stockDisplay.style.display = 'flex';
        } else {
          stockDisplay.style.display = 'none';
        }
      }
    }
   }

  function getNearestPrice(dropdown, attributeName) {
    const options = Array.from(dropdown.querySelectorAll('option'));
    const selectedIndex = options.findIndex(option => option.selected);
    
    // Check the selected option first
    if (options[selectedIndex].getAttribute(attributeName) && options[selectedIndex].getAttribute(attributeName) !== 'null') {
      return options[selectedIndex].getAttribute(attributeName);
    }
    
    // Look for the nearest non-null price, checking options after the selected one first
    for (let i = 1; i < options.length; i++) {
      const forwardIndex = (selectedIndex + i) % options.length;
      const backwardIndex = (selectedIndex - i + options.length) % options.length;
      
      if (options[forwardIndex].getAttribute(attributeName) && options[forwardIndex].getAttribute(attributeName) !== 'null') {
        return options[forwardIndex].getAttribute(attributeName);
      }
      
      if (options[backwardIndex].getAttribute(attributeName) && options[backwardIndex].getAttribute(attributeName) !== 'null') {
        return options[backwardIndex].getAttribute(attributeName);
      }
    }
    
    // If no non-null price is found, return a default value or null
    return 'Price not available';
  }
});



     var mySwiperHowitWorks = new Swiper(".mySwiperHowitWorks", {
      watchSlidesProgress: true,
       spaceBetween: 14,
      slidesPerView: 1.2,
       autoplay: {
           delay: 5000,
         },
      pagination: {
        el: ".swiper-paginationhiw",
      },
      breakpoints: {
        // when window width is >= 320px
        920: {
          slidesPerView: 2.3,
           spaceBetween: 14
        },
        1267: {
          slidesPerView: 3,
          spaceBetween: 12
        }
      }
    });

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  
        

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-section"] && !Shopify.designMode) return;
  try {
    
  var mySwiperHero = new Swiper(".mySwiperHero", {
    watchSlidesProgress: true,
    slidesPerView: 1,
    autoplay: {
      delay: 5000, // 5 seconds
    },
    pagination: {
        el: ".swiper-paginationHero",
      },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landinghowitworks"] && !Shopify.designMode) return;
  try {
    
 var mySwiperHowitWorksLanding = new Swiper(".mySwiperHowitWorksLanding", {
       spaceBetween: 14,
      slidesPerView: 1.1,
      navigation: {
        nextEl: ".swiper-button-nexthiw",
        prevEl: ".swiper-button-prevhiw",
      },
      pagination: {
        el: ".swiper-paginationhiwlanding",
      },
        breakpoints: {
        // when window width is >= 320px
        920: {
          slidesPerView: 2.3,
           spaceBetween: 14
        },
        1267: {
          slidesPerView: 3,
          spaceBetween: 20
        }
      }
    });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["littlelegs-hero"] && !Shopify.designMode) return;
  try {
    
  var mySwiperHero = new Swiper(".mySwiperHero", {
    watchSlidesProgress: true,
    slidesPerView: 1,
    autoplay: {
      delay: 5000, // 5 seconds
    },
    pagination: {
        el: ".swiper-paginationHero",
      },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["littlelegs-hero2"] && !Shopify.designMode) return;
  try {
    
  var mySwiperHero = new Swiper(".mySwiperHero", {
    watchSlidesProgress: true,
    slidesPerView: 1,
    autoplay: {
      delay: 5000, // 5 seconds
    },
    pagination: {
        el: ".swiper-paginationHero",
      },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menubox-carousel"] && !Shopify.designMode) return;
  try {
    
    var mySwiper = new Swiper(".mySwiper", {
      watchSlidesProgress: true,
       spaceBetween: 22,
      slidesPerView: 1.5,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
      },
      breakpoints: {
        // when window width is >= 320px
        920: {
          slidesPerView: 2,
           spaceBetween: 35
        },
        1267: {
          slidesPerView: 3,
          spaceBetween: 35
        }
      }
    });


document.addEventListener('DOMContentLoaded', function() {
  const dropdowns = document.querySelectorAll('.dropdown');
  
  dropdowns.forEach(function(dropdown) {
    const productContainer = dropdown.closest('.carousel-box');
    const priceDisplay = productContainer.querySelector('.product__price');
    const originalPriceDisplay = productContainer.querySelector('.product__price--compare');
    const stockDisplay = productContainer.querySelector('.productstock');
    
    updateProductInfo(dropdown, priceDisplay, originalPriceDisplay, stockDisplay);
    
    dropdown.addEventListener('change', function() {
      updateProductInfo(dropdown, priceDisplay, originalPriceDisplay, stockDisplay);
    });
  });

  function updateProductInfo(dropdown, priceDisplay, originalPriceDisplay, stockDisplay) {
    const selectedOption = dropdown.querySelector('option:checked');
    if (selectedOption) {
      const newPrice = getNearestPrice(dropdown, 'data-price');
      const originalPrice = getNearestPrice(dropdown, 'original-price');
      const stock = selectedOption.getAttribute('data-stock');
      
      const isStarterPack = dropdown.closest('#starterpark') !== null;
      
      if (priceDisplay) {
        priceDisplay.textContent = isStarterPack ? `${newPrice} / box` : newPrice;
        priceDisplay.style.display = 'block'; // Always show, as we're using the nearest price
      }
      
      if (originalPriceDisplay) {
        originalPriceDisplay.textContent = isStarterPack ? `${originalPrice} / box` : originalPrice;
        originalPriceDisplay.style.display = originalPrice ? 'block' : 'none';
      }
      
      if (stockDisplay) {
        if (stock > 0 && stock <= 10) {
          stockDisplay.textContent = 'Only ' + stock + ' left!';
          stockDisplay.style.display = 'flex';
        } else {
          stockDisplay.style.display = 'none';
        }
      }
    }
  }

  function getNearestPrice(dropdown, attributeName) {
    const options = Array.from(dropdown.querySelectorAll('option'));
    const selectedIndex = options.findIndex(option => option.selected);
    
    // Check the selected option first
    if (options[selectedIndex].getAttribute(attributeName) && options[selectedIndex].getAttribute(attributeName) !== 'null') {
      return options[selectedIndex].getAttribute(attributeName);
    }
    
    // Look for the nearest non-null price, checking options after the selected one first
    for (let i = 1; i < options.length; i++) {
      const forwardIndex = (selectedIndex + i) % options.length;
      const backwardIndex = (selectedIndex - i + options.length) % options.length;
      
      if (options[forwardIndex].getAttribute(attributeName) && options[forwardIndex].getAttribute(attributeName) !== 'null') {
        return options[forwardIndex].getAttribute(attributeName);
      }
      
      if (options[backwardIndex].getAttribute(attributeName) && options[backwardIndex].getAttribute(attributeName) !== 'null') {
        return options[backwardIndex].getAttribute(attributeName);
      }
    }
    
    // If no non-null price is found, return a default value or null
    return 'Price not available';
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modal"] && !Shopify.designMode) return;
  try {
    
let checkoutClicked = false;

document.querySelector('.cart__checkout-button').addEventListener('click', function (event) {
  event.preventDefault(); // Prevent the default checkout behavior
  
  checkoutClicked = true; // Mark that the checkout button was clicked
  document.getElementById('myModal').style.display = 'flex';
});

document.querySelector('.close').addEventListener('click', function () {
  document.getElementById('myModal').style.display = 'none';
  
  if (checkoutClicked) {
    window.location.href = '/checkout'; // Redirect to checkout if button was clicked
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shippinginformation"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const track = document.querySelector('.shipping__wrapper--track');
  const carousel = document.querySelector('.shipping__carousel');
  
  // Clone items twice to ensure smooth transition
  const clone1 = carousel.cloneNode(true);
  const clone2 = carousel.cloneNode(true);
  track.appendChild(clone1);
  track.appendChild(clone2);
  
  let currentIndex = 0;
  const itemWidth = 170; // 150px width + 20px gap
  const totalItems = carousel.children.length;
  let animationFrame;
  let lastTimestamp = null;
  const speed = 0.05; // pixels per millisecond - adjust for faster/slower scroll
  
  function animate(timestamp) {
    if (!lastTimestamp) lastTimestamp = timestamp;
    const elapsed = timestamp - lastTimestamp;
    lastTimestamp = timestamp;
    
    currentIndex += speed * elapsed;
    
    // Reset position when first set is completely scrolled
    if (currentIndex >= totalItems * itemWidth) {
      currentIndex = 0;
    }
    
    track.style.transform = `translateX(-${currentIndex}px)`;
    animationFrame = requestAnimationFrame(animate);
  }
  
  // Start animation
  animationFrame = requestAnimationFrame(animate);
  
  // Pause on hover
  track.addEventListener('mouseenter', () => {
    cancelAnimationFrame(animationFrame);
  });
  
  track.addEventListener('mouseleave', () => {
    lastTimestamp = null;
    animationFrame = requestAnimationFrame(animate);
  });
  
  // Handle visibility change
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      cancelAnimationFrame(animationFrame);
    } else {
      lastTimestamp = null;
      animationFrame = requestAnimationFrame(animate);
    }
  });
  
  // Clean up on window unload
  window.addEventListener('unload', () => {
    cancelAnimationFrame(animationFrame);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shopboxes"] && !Shopify.designMode) return;
  try {
    
    var mySwiperShopAll = new Swiper(".mySwiperShopAll", {
      watchSlidesProgress: true,
       spaceBetween: 22,
      slidesPerView: 1.5,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
      },
      breakpoints: {
        // when window width is >= 320px
        920: {
          slidesPerView: 2,
           spaceBetween: 50
        },
        1267: {
          slidesPerView: 3,
          spaceBetween: 50,
           grid: {
            rows: 2,
           fill: "row",
          },
        }
      }
    });


document.addEventListener('DOMContentLoaded', function() {
    // Select all shopdropdown elements within each product
    const dropdowns = document.querySelectorAll('.shopdropdown');

    dropdowns.forEach(function(shopdropdown) {
        // Find the parent product element for this shopdropdown
        const productContainer = shopdropdown.closest('.carousel-box');

        // Find the price display elements within the product container
        const priceDisplay = productContainer.querySelector('.shopproduct__price');
        const originalPriceDisplay = productContainer.querySelector('.shopproduct__price--compare');
        const stockDisplay = productContainer.querySelector('.shopproductstock');

        // Update price, compare at price, and stock for the default selected option
        updateProductInfo(shopdropdown, priceDisplay, originalPriceDisplay, stockDisplay);

        shopdropdown.addEventListener('change', function() {
            // Update price, compare at price, and stock when the shopdropdown changes
            updateProductInfo(shopdropdown, priceDisplay, originalPriceDisplay, stockDisplay);
        });
    });

  function updateProductInfo(shopdropdown, priceDisplay, originalPriceDisplay, stockDisplay) {
    const selectedOption = shopdropdown.querySelector('option:checked');
    if (selectedOption) {
        const newPrice = selectedOption.getAttribute('data-price');
        const originalPrice = selectedOption.getAttribute('original-price');
        const stock = selectedOption.getAttribute('data-stock');

        // Update the price display
        if (priceDisplay) {
            // Creating the span element with the class "boxspan"
            var boxSpan = document.createElement("span");
            boxSpan.className = "boxspan";
            boxSpan.textContent = "/box";

            // Clear existing content in priceDisplay
            priceDisplay.innerHTML = '';

            // Appending the price and boxSpan elements to the price display
            priceDisplay.textContent = newPrice;
            priceDisplay.appendChild(boxSpan);
        }

        // Update the compare at price display, if available
        if (originalPriceDisplay) {
            if (originalPrice) {
                // Creating the span element with the class "boxspan" for originalPriceDisplay
                var originalBoxSpan = document.createElement("span");
                originalBoxSpan.className = "boxspan";
                originalBoxSpan.textContent = "/box";

                // Clear existing content in originalPriceDisplay
                originalPriceDisplay.innerHTML = '';

                // Appending the original price and originalBoxSpan elements to the original price display
                originalPriceDisplay.textContent = originalPrice;
                originalPriceDisplay.appendChild(originalBoxSpan);

                originalPriceDisplay.style.display = 'block'; // Show if hidden
            } else {
                originalPriceDisplay.style.display = 'none'; // Hide if no compare at price
            }
        }

        // Update the stock display
        if (stockDisplay) {
            if (stock > 0 && stock <= 10) {
                stockDisplay.textContent = 'Only ' + stock + ' left!';
                stockDisplay.style.display = 'block'; // Show if hidden
            } else {
                stockDisplay.style.display = 'none'; // Hide if not applicable
            }
        }
    }
}
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video__testimonials-new"] && !Shopify.designMode) return;
  try {
    
  var mySwiperMobile = new Swiper(".mySwiperMobile", {
    watchSlidesProgress: true,
    slidesPerView: 2,
    autoplay: {
      delay: 5000, // 5 seconds
    },
    pagination: {
        el: ".swiper-paginationMobile",
      },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video__testimonialstest"] && !Shopify.designMode) return;
  try {
    
  var mySwiperMobile = new Swiper(".mySwiperMobile", {
    watchSlidesProgress: true,
    slidesPerView: 2,
    autoplay: {
      delay: 5000, // 5 seconds
    },
    pagination: {
        el: ".swiper-paginationMobile",
      },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["videoautoplayer"] && !Shopify.designMode) return;
  try {
    
/* Your JavaScript code goes here, if needed */

  } catch(e) { console.error(e); }
})();
})();
